import { Select, Tooltip } from "antd";
import styled from "styled-components";
import useGetAlvos from "../../../OrdemServico/hooks/useGetAlvos";

interface AlvoSelectProps {
  id: string;
  onChange: (ids: string[]) => void;
  ocupacaoId: string;
  disabled?: boolean;
}

function AlvoSelect({ id, onChange, ocupacaoId, disabled }: AlvoSelectProps) {  
  const { data, isLoading } = useGetAlvos(ocupacaoId);

  return (
    <StyledSelect
      showSearch
      mode="multiple"
      optionFilterProp="text"
      size="large"
      placeholder="Selecione o alvo"
      maxTagCount="responsive"
      maxTagPlaceholder={(omittedValues) => (
        <Tooltip
          title={omittedValues.map((v) => v.label).join(", ")}
          placement="top"
        >
          +{omittedValues.length} itens
        </Tooltip>
      )}
      value={id}
      onChange={e => onChange(e as string[])}
      options={data}
      loading={isLoading}
      disabled={disabled || isLoading}
      fieldNames={{ label: "text", value: "value" }}
    />
  );
}

const StyledSelect = styled(Select)`
  width: 100%;
  
  .ant-select-selector {
    border-radius: 10px !important;
  }
`;

export default AlvoSelect;
